<template>
  <div>
    <el-dialog
      title="添加用户"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="emitClose"
      :width="dialogWidth"
    >
      <!-- <el-link
        type="primary"
        @click="add"
        :underline="false"
      >增加用户</el-link> -->
      <el-form
        :model="dataForm"
        label-position="right"
        ref="formRules"
        :rules="rules"
        label-width="80px"
        size="small"
        class="form"
      >
        <el-form-item prop="mobile" label="手机号">
          <div class="form-item">
            <el-input
              :rows="4"
              type="textarea"
              placeholder="请输入用户手机号"
              v-model="dataForm.mobile"
            >
              <!--  @input="mobileBulr(item,index)" -->
              <!-- <template slot="prepend">手机号</template> -->
            </el-input>
            <!-- <img
              src="@/assets/img/cancel.png"
              alt=""
              srcset=""
              v-if="dataForm.mobile_arr.length>1"
              @click="deleteItem(index)"
            > -->
          </div>
          <!-- <div class="validate">
            {{item.valid}}
          </div> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="emitClose">取 消</el-button>
        <el-button type="primary" @click="submit('formRules')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {
        mobile: "",
      },
      mobile_arr: [],
      rules: {
        mobile: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let testE = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
              let ins = 0
              let flag = this.mobile_arr.some((item,index)=> {
                if(!testE.test(item.mobile)){
                  ins = index + 1
                  return !testE.test(item.mobile)
                }
              })
              if(flag){
                callback(new Error(`第${ins}行请输入正确手机号`));
              }else{
                callback();
              }
            },
          },
        ],
      },
      dialogWidth: document.body.clientWidth < 820 ? "95%" : "480px",
    };
  },
  mounted() {},
  watch: {
    isVisible(val) {
      // this.dataForm.mobile = null
      this.dialogFormVisible = val;
    },
  },
  methods: {
    add() {
      this.dataForm.mobile_arr.push({
        mobile: "",
      });
    },
    emitClose() {
      this.$emit("close");
    },
    mobileBulr(item, index) {
      if (!item.mobile) {
        this.$set(item, "valid", "请输入手机号");
        return;
      } else {
        this.$set(item, "valid", "");
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(item.mobile)) {
        this.$set(item, "valid", "请输入正确的手机号");
        return;
      } else {
        this.$set(item, "valid", "");
      }
    },
    deleteItem(ind) {
      this.dataForm.mobile_arr.splice(ind, 1);
    },
    submit(rules) {
      this.mobile_arr = [];
      this.dataForm.mobile.split("\n").map((item) => {
        this.mobile_arr.push({
          mobile: item,
        });
      });
      this.$refs[rules].validate((valid) => {
        if (valid) {
          this.$emit("submit", this.mobile_arr);
          this.emitClose();
        }
      });
      //  this.$emit('submit', this.dataForm.mobile_arr)
      //   this.emitClose()
      // let a = this.dataForm.mobile_arr.findIndex(v => {
      //   return v.valid
      // })
      // if (a == -1) {
      //   // console.log(this.dataForm.mobile_arr)

      // }
      /*    this.$refs[rules].validate((valid) => {
           if (valid) {
             let query = {
               cid: localStorage.getItem("cid"),
               name: this.dataForm.name,
               year: this.dataForm.year,
               mock_exam_id: this.$route.params.id,
               college_code: this.dataForm.college.value,
               college_name: this.dataForm.college.label,
               major_code: this.dataForm.major.value,
               major_name: this.dataForm.major.label,
               content: JSON.stringify(this.fileList),
               author: this.dataForm.author,
               subjects: this.dataForm.subjects.map(v => {
                 return {
                   subject_code: v.value,
                   subject_name: v.label,
                 }
               })
             }
             mockexampaperCreate(query).then((res) => {
               this.$message.success('提交成功')
               this.$emit('submit')
               this.emitClose()
             });
           } else {
             console.log("error submit!!");
             return false;
           }
         }); */
    },
  },
};
</script>

<style lang="less" scoped>
.form {
  margin-top: 16px;
  .form-item {
    display: flex;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
      margin-left: 32px;
    }
  }
  .validate {
    font-size: 12px;
    color: #f56c6c;
  }
}
</style>